<template>
	<div class="brief-card-container">
		<template v-if="listData.length">
			<!-- 1/2宽度 -->
			<template v-if="styleConfig == 0">
				<div class="item-box" v-for="(item, index) in listData" :key="index" @click="goDetail(item)">
					<div class="info-content">
						<div class="sort">{{ index + 1 }}</div>
						<div class="item-content">
							<h3>{{ item.title }}</h3>
							<p><SvgIcons class="date-icon" name="icon_rili" />{{ formatDateFn(item.time) }}</p>
						</div>
					</div>
					<SvgIcons class="enter-svg" :class="{ 'enter-svg--disabled': item.disabled }" name="right-arrow" />
				</div>
			</template>
			<!-- 全屏展示 -->
			<template v-else>
				<dl class="table-title">
					<dt class="nth-1">{{ $t('Title') }}</dt>
					<dt class="nth-2" v-if="isShowType">{{ $t('Type') }}</dt>
					<dt class="nth-3">{{ $t('Time') }}</dt>
					<dt class="nth-4">{{ $t('View') }}</dt>
				</dl>
				<dl class="table-content" v-for="(item, index) in listData" :key="index" @click="goDetail(item)">
					<dd class="nth-1">{{ item.title }}</dd>
					<dd class="nth-2" v-if="isShowType">{{ item.dataType }}</dd>
					<dd class="nth-3"><SvgIcons class="date-icon" name="icon_rili" />{{ formatDateFn(item.time) }}</dd>
					<dd class="nth-4">
						<SvgIcons
							class="enter-svg"
							:class="{ 'enter-svg--disabled': item.disabled }"
							name="right-arrow"
						/>
					</dd>
				</dl>
			</template>
		</template>
		<Empty v-if="!listData.length" />
	</div>
</template>

<script setup>
import dayjs from 'dayjs';

const props = defineProps({
	styleConfig: {
		type: [String, Number],
		default: 0 //0: 一半宽度 1:全屏
	},
	listData: {
		type: Array,
		default: () => []
	},
	isShowType: {
		type: Boolean,
		default: true
	}
});

const emits = defineEmits(['goToDetail']);
const goDetail = item => {
	emits('goToDetail', item);
};

const formatDateFn = date => {
	return dayjs(date).format('YYYY-MM-DD');
};
</script>

<style lang="less" scoped>
.item-box {
	display: flex;
	justify-content: space-between;
	&:not(:last-child) {
		padding-bottom: 40px;
	}
	cursor: pointer;
	&:hover {
		.enter-svg {
			background: var(--theme-color);
			color: #fff !important;
		}
	}
}
.info-content {
	display: flex;
	gap: 12px;
	.sort {
		margin-top: 4px;
		flex-shrink: 0;
		width: 16px;
		height: 16px;
		background: var(--theme-color);
		clip-path: polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%);
		font-size: 10px;
		color: #fff;
		padding-left: 4px;
		line-height: 16px;
	}
	.item-content {
		h3 {
			width: 411px;
			padding-bottom: 8px;
			color: var(--t-emphasis-color, #1d2129);
			font-size: 16px;

			font-weight: 500;
			line-height: 24px; /* 150% */
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		p {
			display: flex;
			align-items: center;
			color: var(--t-secondary-info-color, #86909c);
			font-size: 14px;
			font-weight: 400;
			line-height: 18px; /* 128.571% */
		}
	}
}
.brief-card-container {
	.enter-svg {
		flex-shrink: 0;
		padding: 12px;
		width: 48px;
		height: 48px;
		border: 1px solid var(--theme-color);
		border-radius: 48px;
		cursor: pointer;
	}
}
.brief-card-container {
	.table-content {
		.nth-4 {
			// 压层级
			.enter-svg {
				&--disabled {
					filter: grayscale(100%);
					opacity: 0.4;
					cursor: not-allowed !important;
					background: transparent !important;
					color: inherit !important;
				}
			}
		}
	}
}

.table-title {
	padding: 9px 0;
	display: flex;
	justify-content: space-between;
	gap: 2.7%;
	margin-bottom: 20px;
	color: var(--t-secondary-info-color, #86909c);
	font-size: 14px;
	font-weight: 500;
	line-height: 18px; /* 128.571% */
	border-bottom: 1px solid #f2f3f5;
	text-align: left;
	dt {
		flex-shrink: 0;
		&:last-child {
			text-align: right;
		}
	}
}

.table-content {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 2.7%;
	text-align: left;
	cursor: pointer;
	&:not(:last-child) {
		padding-bottom: 23px;
	}
	&:hover {
		.enter-svg {
			background: var(--theme-color);
			color: #fff !important;
		}
	}
	dd {
		height: 48px;
		line-height: 48px;
		flex-shrink: 0;
		font-size: 14px;
		color: var(--t-secondary-info-color, #86909c);
		&:nth-child(1) {
			color: var(--t-emphasis-color, #1d2129);
			font-size: 16px;
			font-weight: 500;
		}
		&:last-child {
			text-align: right;
		}
	}
}

.nth-1 {
	width: 63%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.nth-2 {
	width: 9.5%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.nth-3 {
	display: flex;
	align-items: center;
	width: 13%;
}
.nth-4 {
	width: 5%;
}

.date-icon {
	margin-bottom: 1px;
	padding-right: 4px;
	width: 18px;
	height: 18px;
}
</style>
